import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Trigger, UsersQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/users`
const TRIGGERS_URL = `${API_URL}/triggers`

const getTriggers = (query: string, companyId : String): Promise<UsersQueryResponse> => {
  return axios
    .get(`${TRIGGERS_URL}/all/${companyId}?${query}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getSingleTrigger = (id: ID,companyId : String): Promise<Trigger | undefined> => {
  return axios
    .get(`${TRIGGERS_URL}/${companyId}/${id}`)
    .then((response: AxiosResponse<Response<Trigger>>) => response.data)
    .then((response: Response<Trigger>) => response.data)
}

const createTriggers = (trigger: Trigger, companyId : String): Promise<Trigger | undefined> => {
  return axios
    .post(`${TRIGGERS_URL}/${companyId}`, trigger)
    .then((response: AxiosResponse<Response<Trigger>>) => response.data)
    .then((response: Response<Trigger>) => response.data)
}

const updateUserDetail = (user: Trigger): Promise<Trigger | undefined> => {
  return axios
    .patch(`/${user._id}`, user)
    .then((response: AxiosResponse<Response<Trigger>>) => response.data)
    .then((response: Response<Trigger>) => response.data)
}

const updateTrigger = (user: Trigger, id : any, companyId : string): Promise<Trigger | undefined> => {
  return axios
    .patch(`${TRIGGERS_URL}/${companyId}/${id}`, user)
    .then((response: AxiosResponse<Response<Trigger>>) => response.data)
    .then((response: Response<Trigger>) => response.data)
}

const updatePassword = (user: Trigger): Promise<Trigger | undefined> => {
  
  return axios
    .post(``, user)
    .then((response: AxiosResponse<Response<Trigger>>) => response.data)
    .then((response: Response<Trigger>) => response.data)
}

const deleteTrigger = (userId: ID, companyId : string): Promise<void> => {
  return axios.delete(`${TRIGGERS_URL}/${companyId}/${userId}`).then(() => {})
}



const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getTriggers, deleteTrigger, deleteSelectedUsers, getSingleTrigger, createTriggers, updateTrigger,updateUserDetail,updatePassword}
